import { FC } from "react";

interface MarginaliaListItem {
	label: string;
	scrollTo?: string;
}

interface MarginaliaListProps {
	items: MarginaliaListItem[];
}

const MarginaliaList: FC<MarginaliaListProps> = ({ items }) => {
	const handleClick = (scrollTo: string) => {
		const el = document.getElementById(scrollTo);
		if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
	};

	return (
		<ul className="flex flex-col gap-1.5">
			{items.map((item, i) => (
				<li key={i} className="flex items-start gap-2">
					<span className="mt-[7px] w-1.5 h-1.5 rounded-full bg-[#ccc] shrink-0" />
					{item.scrollTo ? (
						<button
							onClick={() => handleClick(item.scrollTo!)}
							className="text-sm text-[#666] text-left hover:text-secondary hover:underline focus:outline-none"
						>
							{item.label}
						</button>
					) : (
						<span className="text-sm text-[#666]">{item.label}</span>
					)}
				</li>
			))}
		</ul>
	);
};

export { MarginaliaList };
